import axios from 'axios'

const expertosRegionales = {
    state: () => ({
        expertosRegionales: [],
        expertoRegional: {}
    }),

    getters: {
        obtenerExpertosRegionales(state) {
            return state.expertosRegionales
        },

        obtenerExpertoRegional(state) {
            return state.expertoRegional
        },

        obtenerExpertosRegionalesWorldSkills : (state) => (competencia, habilidad) => {
            return state.expertosRegionales.filter(expertoRegional => expertoRegional.competencia_id == competencia && expertoRegional.categoria_id == habilidad)
        },

        obtenerExpertoRegionalWorldSkills: (state) => (id) => {
            return state.expertosRegionales.find(expertoRegional => expertoRegional.id == id)
        },

        obtenerExpertoRegionalCompetencia: (state) => (competencia, identificacion) => {
            return state.expertosRegionales.find(expertoRegional => expertoRegional.competencia_id == competencia && expertoRegional.identificacion == identificacion)
        }
    },

    mutations: {
        enviarExpertosRegionales(state, expertosRegionales) {
            state.expertosRegionales = expertosRegionales
        },

        enviarExpertoRegional(state, expertoRegional) {
            state.expertoRegional = expertoRegional
        }
    },

    actions: {
        registrarExpertoRegional(context, experto) {
            return new Promise((resolve, reject) => {
                axios.post("api/worldskills/expertosRegionales", experto)
                .then((response) => resolve(response.data))
                .catch(() => reject())
            })
        },

        gestionarExpertosRegionales(context, competencia) {
            axios.get(`api/worldskills/competencias/${competencia}/expertosRegionales`)
            .then((response) => {
                const expertosRegionales = []
                response.data.results.forEach((response) => {
                    expertosRegionales.push({
                        id:                     response.id_lider,
                        competencia_id:         response.competencia.id_competencia,
                        competencia:            response.competencia.competencia,
                        categoria_id:           response.categoria.id_categoria,
                        categoria:              response.categoria.categoria,
                        tipo_lider_id:          response.tipo_lider.id_tipo_lider,
                        tipo_lider:             response.tipo_lider.tipo_lider,
                        centro_formacion_id:    response.centro_formacion.id_centro_formacion,
                        centro_formacion:       response.centro_formacion.centro_formacion,
                        regional_id:            response.centro_formacion.regional.id_regional,
                        regional:               response.centro_formacion.regional.regional,
                        persona_id:             response.persona.id_persona,
                        tipo_identificacion_id: response.persona.tipo_identificacion_id,
                        identificacion:         response.persona.identificacion,
                        nombres:                response.persona.primer_nombre+" "+response.persona.segundo_nombre,
                        apellidos:              response.persona.primer_apellido+" "+response.persona.segundo_apellido,
                        correo:                 response.persona.correo,
                        telefono_movil:         response.persona.telefono_movil,
                        direccion:              response.persona.direccion,
                        fecha_nacimiento:       response.persona.fecha_nacimiento,
                        genero_id:              response.persona.genero_id,
                        estado_civil_id:        response.persona.estado_civil_id,
                        estrato:                response.persona.estrato,
                        zona_id:                response.persona.zona_id,
                        discapacidad_id:        response.persona.discapacidad_id,
                        cargo:                  response.cargo,
                        talla_camiseta:         response.talla_camiseta,
                    })
                })
                context.commit("enviarExpertosRegionales", expertosRegionales)
            })
            .catch(() => {})
        },
        
        detallesExpertoRegional(context, experto) {
            axios.get("api/worldskills/expertosRegionales/"+experto)
            .then((response) => {
                const expertoRegional = {
                    id:                     response.data.results.id_lider,
                    competencia_id:         response.data.results.competencia.id_competencia,
                    competencia:            response.data.results.competencia.competencia,
                    categoria_id:           response.data.results.categoria.id_categoria,
                    categoria:              response.data.results.categoria.categoria,
                    tipo_lider_id:          response.data.results.tipo_lider.id_tipo_lider,
                    tipo_lider:             response.data.results.tipo_lider.tipo_lider,
                    centro_formacion_id:    response.data.results.centro_formacion.id_centro_formacion,
                    centro_formacion:       response.data.results.centro_formacion.centro_formacion,
                    regional_id:            response.data.results.centro_formacion.regional.id_regional,
                    regional:               response.data.results.centro_formacion.regional.regional,
                    persona_id:             response.data.results.persona.id_persona,
                    identificacion:         response.data.results.persona.identificacion,
                    nombres:                response.data.results.persona.primer_nombre+" "+response.data.results.persona.segundo_nombre,
                    apellidos:              response.data.results.persona.primer_apellido+" "+response.data.results.persona.segundo_apellido,
                    telefono_movil:         response.data.results.persona.telefono_movil,
                    fecha_nacimiento:       response.data.results.persona.fecha_nacimiento,
                    correo:                 response.data.results.persona.correo,
                    genero:                 response.data.results.persona.genero.genero,
                    cargo:                  response.data.results.cargo,
                    talla_camiseta:         response.data.results.talla_camiseta
                }

                context.commit("enviarExpertoRegional", expertoRegional)
            })
        },

        actualizarExpertoRegional(context, experto) {
            return new Promise((resolve, reject) => {
                axios.put("api/worldskills/expertosRegionales/"+experto.id, experto)
                .then((response) => resolve(response.data))
                .catch(() => reject())
            })
        },

        eliminarExpertoRegional(context, experto) {
            return new Promise((resolve, reject) => {
                axios.delete("api/worldskills/expertosRegionales/"+experto)
                .then((response) => resolve(response.data))
                .catch(() => reject())
            })
        },

        // expertos regionales adjudicar
        adjudicarExpertosRegionalesWorldskills(context, competencia) {
            return new Promise((resolve, reject) => {
                axios.post("api/expertosRegionalesWorldskillsAdjudicar", competencia)
                .then((response) => {
                    resolve(response.data)
                })
                .catch(() => {
                    reject()
                })
            })
        }
    }
}

export default expertosRegionales